module.exports = __webpack_public_path__ + "img/no-data.cdfb7898.png";